import { createContext, useContext, useCallback, ReactNode } from "react";
import { useLocalStorageState } from "hooks/useLocalStorageState";

interface WasteSubmissionStatsContextType {
  statsOpen: boolean;
  handleToggle: () => void;
}

const WasteSubmissionStatsContext = createContext<
  WasteSubmissionStatsContextType | undefined
>(undefined);

export function WasteSubmissionStatsProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [statsOpen, setStatsOpen] = useLocalStorageState<boolean>(
    "wasteSubmissionsStatsOpen",
    {
      defaultValue: true, // Stats open by default, persisted when user toggles
    }
  );

  const handleToggle = useCallback(() => {
    setStatsOpen((prevState) => !prevState);
  }, [setStatsOpen]);

  return (
    <WasteSubmissionStatsContext.Provider value={{ statsOpen, handleToggle }}>
      {children}
    </WasteSubmissionStatsContext.Provider>
  );
}

export function useWasteSubmissionStats() {
  const context = useContext(WasteSubmissionStatsContext);
  if (context === undefined) {
    throw new Error(
      "useWasteSubmissionStats must be used within a WasteSubmissionStatsProvider"
    );
  }
  return context;
}
